export default {
  label: '税务管理',
  id: '0',
  children: [
    {
      label: '岗位定义',
      id: '0-1',
      children: [
        {
          label: '专注于税务申报、税务筹划等工作',
          id: '0-1-1',
        },
      ],
    },
    {
      label: '岗位职责',
      id: '0-2',
      children: [
        {
          label: '按照税务要求完成纳税申报、缴纳、退税等工作',
          id: '0-2-1',
        },
        {
          label: '审核原始凭证的合法性、合理性和真实性，确保税务合规',
          id: '0-2-2',
        }
      ],
    },
    {
      label: '技能要求',
      id: '0-3',
      children: [
        {
          label: '学历要求：大专及以上学历，财会相关专业优先',
          id: '0-3-1',
        },
        {
          label: '技能要求：熟练使用ERP系统或其他财务软件，具备良好的数据分析能力和沟通能力',
          id: '0-3-2',
        },
        {
          label: '职业素养：具有较强的责任心、保密意识和团队合作精神',
          id: '0-3-3',
        }
      ],
    }
  ],
};